"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoundedRectangleButton = void 0;
const react_1 = __importDefault(require("react"));
const button_1 = __importDefault(require("antd/lib/button"));
const RoundedRectangleButton = _a => {
  var title = _a.title,
    style = _a.style,
    buttonProps = __rest(_a, ["title", "style"]);
  return react_1.default.createElement("div", {
    style: style
  }, react_1.default.createElement(button_1.default, Object.assign({}, buttonProps), title));
};
exports.RoundedRectangleButton = RoundedRectangleButton;
exports.default = exports.RoundedRectangleButton;